import React from "react";

const Pages_Lcc = () => {
  return <div>Pages_Lcc</div>;
};

export default Pages_Lcc;
